export default __webpack_public_path__ + "static/media/Animals-08.3c754f7e.png";